/* Tarjeta única del catálogo Velantis. Generada desde catalogo-casas.js. */
(function(){'use strict';
function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
function cap(s){s=String(s||'').trim();return s?s.charAt(0).toUpperCase()+s.slice(1):'';}
function notas(r){var t=[r[5],r[6],r[7]].filter(Boolean).join(', ').replace(/\s*,\s*/g,', ').trim();return cap(t.replace(/\.$/,''));}

var photoSource=null,photoIndex={};
function photo(name){var source=window.VELANTIS_FOTOS||{};if(source!==photoSource){photoSource=source;photoIndex={};Object.keys(source).forEach(function(k){photoIndex[String(k).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]/g,'')]=source[k];});}return source[name]||photoIndex[String(name).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]/g,'')]||'';}
function photoMarkup(name){var url=photo(name);if(!url)return '<div class="rl-static-photo" data-photo-name="'+esc(name)+'"><span>Velantis</span></div>';var base=url.replace(/([?&])width=\d+&?/,'$1').replace(/[?&]$/,'');var sep=base.indexOf('?')<0?'?':'&';return '<div class="rl-static-photo" data-photo-name="'+esc(name)+'" data-ready="1"><img src="'+esc(base+sep+'width=480')+'" srcset="'+esc(base+sep+'width=320')+' 320w, '+esc(base+sep+'width=640')+' 640w" sizes="(max-width:600px) 84vw, 300px" width="600" height="600" alt="'+esc(name)+'" loading="lazy" decoding="async"></div>';}

window.VelantisProductCard={housesBySku:{"V419":"Dior"},render:function(x,casa,femenino,soloElla,options){
 casa=window.VelantisProductCard.housesBySku[x.r[12]]||casa;
 options=options||{};var PRE=options.preventa||{},mapa=options.mapa||{};
 function precio(n,t){var v=((t==='50'?mapa.precios50:mapa.precios)||{})[n];return v==null?null:Math.round(v);}
  function tarjeta(x, casa, femenino, soloElla){
    if(x.ace) return tarjetaAceite(x, casa);
    var r = x.r, fam = r[9] === 'amb-0' ? 'amb' : (r[9] || 'amaderados');
    var p100 = precio(r[0], '100'), p50 = precio(r[0], '50');
    var pv = p100 != null ? p100 : (r[11] || (x.amb ? 449 : 590));
    /* TODA ficha de dama se marca, tenga o no la casa un acento femenino propio:
       la distincion es relleno contra contorno, no el tono. Antes, en las casas sin
       acento definido, las de dama salian igual que las de caballero. */
    var ella = r[1] === 'Dama';
    var n = notas(r);
    /* La tarjeta de noche, con las notas flotando sobre el azul, es solo para las
       veinte lanzamientos recientes (15-sep: la casa aclara que NO son preventa; ya estan disponibles). El resto del catalogo lleva la ficha clara de siempre. */
    var pre = PRE[r[12]] ? ' cc-pre' : '';
    return '<article class="cat-card cc-card' + pre + (ella ? ' ella' : '') + '" data-i="' + x.i + '" tabindex="0"' +
      ' data-name="' + esc(r[0]) + '" data-price="' + pv + '" data-img="n-' + esc(fam) + '"' +
      ' data-sub="' + esc(r[3]) + '" data-sku="' + esc(r[12] || '') + '"' +
      (ella && femenino && !soloElla ? ' style="--c:' + femenino + '"' : '') + '>' +
      photoMarkup(r[0]) +
      '<div class="cat-body">' +
        '<div class="cat-top"><span class="cat-fam">' + esc(r[3]) + '</span>' +
        '<span class="cat-para">' + esc(x.amb ? 'Aromatizante' : r[1]) + '</span></div>' +
        '<div class="cat-code">' + esc(r[12] || '') + (pre ? '<b class="cc-sello">Lanzamiento</b>' : '') + '</div>' +
        '<p class="cat-kicker">Inspirado en</p>' +
        '<h3>' + esc(x.amb ? x.ref : r[0]) + '</h3>' +
        '<p class="cat-house">' + esc(casa) + '</p>' +
        (x.amb ? '<p class="cat-ml">Aromatizante · 250 ml</p>' : '') +
        (n ? '<p class="cat-notes">' + esc(n) + '</p>' : '') +
        '<div class="cat-foot"><span class="cat-price">$' + pv.toLocaleString('es-MX') + ' MXN</span>' +
        '</div>' +
        '<button class="add" type="button">Agregar al carrito</button>' +
      '</div></article>';
  }

  /* El aceite usa el marcado de la tarjeta del catálogo, con tres cosas del aceite del
     sitio: `data-name` «Nombre · Aceite 100 ml» (así lo cobra el carrito y así lo
     encuentra el mapa vivo), la clase `oil-img` y `data-lhs` en la imagen (así el motor
     lo dibuja con la fórmula del aceite y no con la del perfume homónimo). El clic va
     directo a su página de producto; ver abajo. */
  function tarjetaAceite(x, casa){
    var r = x.r, nombre = r[0] + ' · Aceite 100 ml';
    var pv = precio(nombre, '100'); if(pv == null) pv = 450;
    var n = notas(r);
    return '<article class="cat-card cc-card cc-ace" data-i="' + x.i + '" tabindex="0"' +
      ' data-name="' + esc(nombre) + '" data-price="' + pv + '" data-img="oil-ph"' +
      ' data-sub="Aceite para difusor · 100 ml" data-sku="' + esc(r[12]) + '" data-h="' + esc(x.h || '') + '">' +
      photoMarkup(nombre) +
      '<div class="cat-body">' +
        '<div class="cat-top"><span class="cat-fam">Aceite para difusor</span>' +
        '<span class="cat-para">Aceite</span></div>' +
        '<div class="cat-code">' + esc(r[12]) + '</div>' +
        '<p class="cat-kicker">Inspirado en</p>' +
        '<h3>' + esc(x.ref) + '</h3>' +
        '<p class="cat-house">' + esc(casa) + '</p>' +
        '<p class="cat-ml">Aceite para difusor · 100 ml</p>' +
        (n ? '<p class="cat-notes">' + esc(n) + '</p>' : '') +
        '<div class="cat-foot"><span class="cat-price">$' + pv.toLocaleString('es-MX') + ' MXN</span>' +
        '</div>' +
        '<button class="add" type="button">Agregar al carrito</button>' +
      '</div></article>';
  }

return tarjeta(x,casa,femenino,soloElla);}};
})();
